export const constructAuthHeaders = token => ({
  headers: { authorization: `Token ${token}` },
});
